import { Field, FieldProps } from 'formik';
import React from 'react';
import { FieldConfigProps } from '../types';
import { MobileTimePicker, MobileTimePickerProps } from '@mui/x-date-pickers';
import { Box, inputLabelClasses, styled } from '@mui/material';
import { formatDate } from '@/utils';

const Container = styled(Box)(() => ({
    [`& .${inputLabelClasses.root}`]: {
        transform: 'translate(14px, 11px) scale(1) !important',
    },
    [`& .${inputLabelClasses.shrink}`]: {
        transform: 'translate(14px, -9px) scale(0.75) !important',
    },
}));

type FormTimePickerProps = FieldConfigProps & Partial<MobileTimePickerProps<Date>>;

export const FormTimePicker: React.FunctionComponent<FormTimePickerProps> = ({ name, validate, ...rest }) => {
    return (
        <Container>
            <Field name={name} validate={validate}>
                {({ field, form: { setFieldValue } }: FieldProps) => {
                    return (
                        <MobileTimePicker
                            {...rest}
                            {...field}
                            onChange={(date, context) => {
                                rest.onChange?.(date, context);
                                if (date) {
                                    setFieldValue(
                                        name,
                                        formatDate(date, { withTime: true, pattern: 'MM/dd/yyyy HH:mm:ss z' }),
                                    );
                                }
                            }}
                            slotProps={{
                                textField: {
                                    variant: 'outlined',
                                    fullWidth: true,
                                },
                            }}
                        />
                    );
                }}
            </Field>
        </Container>
    );
};
